<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p class="c-modal__title c-text c-text--xl"></p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content">
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up u-no-pr u-no-p@up-to-md" *ngIf="vm.initialized">
				<p class="c-text c-text--bold c-text--lg u-osb-sm">{{ 'Chats.Other.My_Chat_Availability' | translate }}</p>
				
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Chats.Other.Chat_Notifications_Over_Email' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">
				            <input-switch-new style="float:right;" [isDisabled]="vm.hasNotificationsDisabled"
				                      [toggleFn]="vm.enableNotificationViaEmail"
				                      [label]="">
				            </input-switch-new>
						</p>
					</div>
				</div>
				
				<div class="o-grid u-osb-xs">
					<div class="o-grid__cell o-grid__cell--slim u-no-pl">
						<p class="c-text c-text--gray">{{ 'Chats.Other.Mobile_App_Info' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
						<p class="c-text c-text--right">
							<i aria-hidden="true" *ngIf="!vm.extraInfo.myChatAvailability.hasUsedApp" class="o-icon o-icon--cancel u-no-mr c-text" style="line-height: 1; color: red;padding-right: 20px;"></i>
							<i aria-hidden="true" *ngIf="vm.extraInfo.myChatAvailability.hasUsedApp && !vm.extraInfo.myChatAvailability.appLastUsed" class="o-icon o-icon--check u-no-mr c-text" style="line-height: 1; color: green;padding-right: 20px;"></i>
							<span *ngIf="vm.extraInfo.myChatAvailability.appLastUsed" class="c-text">{{ vm.extraInfo.myChatAvailability.appLastUsed | date:'dd.MM.yyyy' }}</span>
						</p>
					</div>
				</div>
				
				<div>
					<p style="padding-top:20px;padding-bottom:10px;" class="c-text c-text--spaced c-text--wrap">{{ 'Chats.Other.Mobile_App_Download_Info' | translate }}</p>
					<div class="o-grid o-grid--center-v" *ngIf="vm.appLogoLang">
						<div style="padding-left:0px !important;" class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
							<a href="{{vm.iosLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/app-store-en.png" alt="App Store">
							</a>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
							<a href="{{vm.androidLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/google-play-en.png"
								alt="Google Play">
							</a>
						</div>
					</div>
				</div>
			
				<div class="c-divider c-divider--h c-divider--light" *ngIf="vm.extraInfo.chatAvailability"></div>
			
				<ng-container *ngIf="vm.extraInfo.chatAvailability">
					<p class="c-text c-text--bold c-text--lg u-osb-sm">{{ vm.user?.firstname }} {{ vm.user?.lastname }}</p>
					<div class="o-grid u-osb-xs">
						<div class="o-grid__cell o-grid__cell--slim u-no-pl">
							<p class="c-text c-text--gray">{{ 'Modal.Form.Label.Phone_Number' | translate }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
							<p class="c-text c-text--right">
								<span *ngIf="vm.extraInfo.chatAvailability.phoneValid">{{ vm.extraInfo.chatAvailability.phone }}</span>
								<i *ngIf="!vm.extraInfo.chatAvailability.phoneValid" class="o-icon o-icon--cancel u-no-mr c-text" style="line-height: 1; color: red;padding-right: 20px;"></i>
							</p>
						</div>
					</div>
					<div class="o-grid u-osb-xs">
						<div class="o-grid__cell o-grid__cell--slim u-no-pl">
							<p class="c-text c-text--gray">{{ 'Modal.Form.Label.Email' | translate }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
							<p class="c-text c-text--right" [ngStyle]="{ color: vm.extraInfo.chatAvailability.emailValid ? 'green' : 'red' }">{{ vm.extraInfo.chatAvailability.email }}</p>
						</div>
					</div>
					<div class="o-grid u-osb-xs">
						<div class="o-grid__cell o-grid__cell--slim u-no-pl">
							<p class="c-text c-text--gray">{{ 'Chats.Other.Chat_Notifications_Over_Email' | translate }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
							<p class="c-text c-text--right">
								<i aria-hidden="true" *ngIf="!vm.extraInfo.chatAvailability.hasEmailNotifications" class="o-icon o-icon--cancel u-no-mr c-text" style="line-height: 1; color: red;padding-right: 20px;"></i>
								<i aria-hidden="true" *ngIf="vm.extraInfo.chatAvailability.hasEmailNotifications" class="o-icon o-icon--check u-no-mr c-text" style="line-height: 1; color: green;padding-right: 20px;"></i>
							</p>
						</div>
					</div>
					<div class="o-grid u-osb-xs">
						<div class="o-grid__cell o-grid__cell--slim u-no-pl">
							<p class="c-text c-text--gray">{{ 'Chats.Other.Mobile_App_Info' | translate }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
							<p class="c-text c-text--right">
								<i aria-hidden="true" *ngIf="!vm.extraInfo.chatAvailability.hasUsedApp" class="o-icon o-icon--cancel u-no-mr c-text" style="line-height: 1; color: red;padding-right: 20px;"></i>
								<i aria-hidden="true" *ngIf="vm.extraInfo.chatAvailability.hasUsedApp && !vm.extraInfo.chatAvailability.appLastUsed" class="o-icon o-icon--check u-no-mr c-text" style="line-height: 1; color: green;padding-right: 20px;"></i>
								<span *ngIf="vm.extraInfo.chatAvailability.appLastUsed" class="c-text">{{ vm.extraInfo.chatAvailability.appLastUsed | date:'dd.MM.yyyy' }}</span>
							</p>
						</div>
					</div>
					
					<div class="o-grid">
						<p style="padding-top:20px;" class="c-text c-text--bold c-text--spaced c-text--wrap">{{ 'Chats.Other.Chat_Notify_About_Messages' | translate }}</p>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="c-modal__footer">
			<div class="o-grid" *ngIf="vm.extraInfo.chatAvailability">
				
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
					<button [disabled]="!vm.extraInfo.chatAvailability.phoneValid || vm.sending" id="sendSmsButton" type="button" class="c-button c-button--s1 c-button--fixed" (click)="vm.sendSms()">{{ 'Chats.Other.Chat_Notify_Sms_Button' | translate }}</button>
					<span>&nbsp;</span>
					<button [disabled]="!vm.extraInfo.chatAvailability.emailValid || vm.extraInfo.chatAvailability.hasEmailNotifications || vm.sending" id="sendEmailbutton" type="button" class="c-button c-button--s1 c-button--fixed" (click)="vm.sendEmail()">{{ 'Chats.Other.Chat_Notify_Email_Button' | translate }}</button>
				</div>
			</div>
		</div>
	</div>
</div>
